export default {
  'small.language.tooltip': '🎉 多语言语料库研究合作申请火热进行中，快来报名吧！',
  'small.language.apply': '申请合作',
  'multilingual.common.apply': '立即申请',
  'multilingual.title': '专题课题参考',
  'multilingual.protocol': '本项目遵从 Apache License 2.0',
  'multilingual.list': [
    {
      title: '多语言模型微调与性能优化课题',
      goal: {
        label: '课题目标',
        value: '针对特定语言，利用现有的进行微调和优化，提升其对该语言的理解和生成能力'
      },
      contentList: {
        label: '研究内容',
        value: [
          '基于本平台开源的多语言语料，进行现有大模型的迁移学习或微调',
          '评估并优化模型在某一语言任务上的表现，如机器翻译、文本分类、情感分析等',
          ' 开发新的评估指标，特别针对某一语言的复杂性和独特性进行调优'
        ]
      },
      expected: {
        isLabelImage: true,
        value: '建立跨语言、跨领域的多语言高质量语料库，支持 NLP 研究应用'
      }
    },
    {
      title: '多语言智能助手应用开发课题',
      goal: {
        label: '课题目标',
        value: '针对特定语言，利用现有的大模型“书生·浦语2.0”，开发用于新闻助手、智能翻译助手等应用场景的多语言 AI 工具'
      },
      contentList: {
        label: '研究内容',
        value: [
          '基于本平台开源的多语言语料，训练适应面向某一语言环境的智能新闻助手',
          '探索多语言支持的翻译系统，尤其是在多语言与某一语言间的跨语言翻译',
          '针对企业出海需求，开发某一语言助手工具，为国际市场提供服务'
        ]
      },
      expected: {
        isLabelImage: true,
        value: '推出一款语言理解和生成能力的智能助手，面向新闻和翻译场景'
      }
    },
    {
      title: '跨语言企业出海智能工具研发课题',
      goal: {
        label: '课题目标',
        value: '针对特定语言，利用现有的大模型“书生·浦语2.0”，开发一款智能工具，帮助企业在不同语言环境下进行国际化运营'
      },
      contentList: {
        label: '研究内容',
        value: [
          '基于本平台开源的多语言语料，开发智能化的多语言营销、客户服务和内容生成工具',
          '探讨跨文化传播中的语言障碍，开发智能解决方案',
          '开发支持多语言的智能翻译系统，用于市场推广材料等方向的内容自动翻译与优化'
        ]
      },
      expected: {
        isLabelImage: true,
        value: '推出一款针对企业出海的多语言智能工具，帮助企业进入新兴市场'
      }
    },
    {
      title: '多语言大模型评价与优化机制研究课题',
      goal: {
        label: '课题目标',
        value: '探讨现有大模型在多语言对话中的表现与不足，并开发评价与优化机制，提升其跨语言能力'
      },
      contentList: {
        label: '研究内容',
        value: [
          '分析当前主流语言模型在不同语言任务中的性能差异',
          '开发针对多语言的专用评价标准，如词汇多样性、句法复杂性等',
          '提出优化方案，提升模型在特定语言的泛化能力和准确性'
        ]
      },
      expected: {
        isLabelImage: true,
        value: '建立一套完善的多语言 大模型评价机制，并提出改进策略'
      }
    },
    {
      title: '多语言语料库建设与开放课题',
      goal: {
        label: '课题目标',
        value: '基于 MinerU API 完善和扩展现有多语言语料库，提升其在多语言自然语言处理（NLP）中的应用价值'
      },
      contentList: {
        label: '研究内容',
        value: [
          '基于 MinerU 的 API，对现有语料进行清理、分类和标注，提升语料标准化程度',
          '针对特定语言，如阿拉伯语、匈牙利语等，探索高效的语料收集方法',
          '建立开放的语料库共享平台，提供多语言 NLP 研究的基础数据'
        ]
      },
      expected: {
        isLabelImage: true,
        value: '建立跨语言、跨领域的多语言高质量语料库，支持 NLP 研究应用'
      }
    },
    {
      title: '多语言对话模型对齐评测基准构建课题',
      goal: {
        label: '课题目标',
        value: '基于本平台开源的多语言语料，构建大模型多维度多语言对齐评测基准，目标成为该方向的行业标准'
      },
      contentList: {
        label: '研究内容',
        value: [
          '构建符合实际应用场景的多样化、具有挑战性的多维度多语言对齐评测基准',
          '可分为基本能力、中文理解、综合问答、写作能力、逻辑推理、数学能力、角色扮演和专业知识 8 个类别'
        ]
      },
      expected: {
        isLabelImage: true,
        value: '提供优化后的多语言模型，并通过性能基准测试'
      }
    },
    {
      title: '多语言语料的自动标注与生成工具开发',
      goal: {
        label: '课题目标',
        value: '基于本平台开源的多语言语料，开发一款针对特定语言语料进行自动标注与生成工具，提高语料扩展效率'
      },
      contentList: {
        label: '研究内容',
        value: [
          '针对多语言文本，开发自动分词、词性标注、句法分析工具',
          '优化标注工具的精度和适用性，降低人工干预成本',
          '能够针对本平台开源的多语言语料，生成多样化、高质量的语料'
        ]
      },
      expected: {
        isLabelImage: true,
        value: '发布一套多语言语料标注与生成工具，支持语言研究与 AI 训练'
      }
    },
    {
      title: '多语言智能教育系统的研究与开发',
      goal: {
        label: '课题目标',
        value: '基于本平台开源的多语言语料，与大模型“书生·浦语2.0”，开发智能教育系统，助力语言学习和文化传播'
      },
      contentList: {
        label: '研究内容',
        value: [
          '开发多语言虚拟教师模块，实现发音纠正、语法分析、即时反馈等功能',
          '构建基于多模态数据（文本、语音、图像）的语言教学资源库',
          '测试系统在真实教育场景中的应用效果，并优化交互体验'
        ]
      },
      expected: {
        isLabelImage: true,
        value: '发布一款多语言智能教育平台，支持个性化语言学习'
      }
    }
  ],
  'miniLang.apply.modal.title': '多语言语料库研究合作申请',
  'miniLang.apply.modal.subtitle': '请完整填写以下信息，以帮助我们了解您的研究需求并为您提供最适合的资源支持，您的数据将被严格保密',
  'miniLang.apply.form.name.label': '您的真实姓名',
  'miniLang.apply.form.name.placeholder': '请输入真实姓名，避免昵称或简写',
  'miniLang.apply.form.name.required': '请输入真实姓名',
  'miniLang.apply.form.email.label': '您的联系邮箱',
  'miniLang.apply.form.email.placeholder': '请输入',
  'miniLang.apply.form.email.required': '请输入有效的邮箱地址',
  'miniLang.apply.form.wx.label': '您的微信号是',
  'miniLang.apply.form.wx.placeholder': '请输入',
  'miniLang.apply.form.wx.required': '请输入微信号',
  'miniLang.apply.form.company.label': '您的申请单位',
  'miniLang.apply.form.company.placeholder': '请填写您公司或单位的全称，避免简写或缩写',
  'miniLang.apply.form.company.required': '请输入申请单位',
  'miniLang.apply.form.research.label': '您的研究介绍',
  'miniLang.apply.form.research.placeholder': '请简述研究内容与背景',
  'miniLang.apply.form.research.required': '请输入研究介绍',
  'miniLang.apply.form.dataType.label': '选择您需要的语料数据类型',
  'miniLang.apply.form.dataType.placeholder': '至少选一项',
  'miniLang.apply.form.dataType.required': '请选择数据类型',
  'miniLang.apply.form.expect.label': '使用语料研究的预期成果',
  'miniLang.apply.form.expect.placeholder': '请简要描述预期的研究成果',
  'miniLang.apply.form.expect.required': '请输入预期成果',
  'miniLang.apply.form.submit': '提交',

  'miniLang.apply.form.langForm.option1': '阿拉伯语-nlp语料',
  'miniLang.apply.form.langForm.option2': '俄语-nlp语料',
  'miniLang.apply.form.langForm.option3': '韩语-nlp语料',
  'miniLang.apply.form.langForm.option4': '越南语-nlp语料',
  'miniLang.apply.form.langForm.option5': '泰语-nlp语料',
  'miniLang.apply.form.langForm.option6': '匈牙利语-nlp语料',
  'miniLang.apply.form.langForm.option7': '塞尔维亚语-nlp语料',
  'miniLang.apply.form.langForm.option8': '捷克语-nlp语料',

  'miniLang.apply.form.langForm.label': '您研究的语言',
  'miniLang.apply.form.langForm.required': '选择您需要的语',
  'miniLang.apply.form.langForm.placeholder': '至少选一项',

  'miniLang.apply.form.dataType.option1': '音频',
  'miniLang.apply.form.dataType.option2': '视频',
  'miniLang.apply.form.dataType.option3': '图文',
  'miniLang.apply.form.dataType.option4': '文本',
  'miniLang.apply.form.dataType.option5': 'sft',
  'miniLang.apply.form.dataType.option6': '平行语料',

  'miniLang.success.modal.title': '提交成功',
  'miniLang.success.modal.subtitle': '审批结果将发送至您的邮箱，请耐心等待',
  'miniLang.success.modal.button': '我知道了',
  'miniLang.tab1': '专项课题',
  'miniLang.tab2': '多语言语料库'
};
